/*
 * @Author: 徐吉文
 * @LastEditors: 李青花
 * @description: 应用状态管理
 * @Date: 2021-07-20 10:23:19
 * @LastEditTime: 2022-03-21 10:49:47
 */
import { post } from '../utils/request.js';
import { Dialog } from 'vant';
import { inputInstallCountValidate, installCountValidate } from 'src/config/constant.config'
import _ from 'lodash';
import { isWebsite,getTrackServiceName,isMobile } from '../model/common.js';
// promo model
import { getPromocodeListForService } from "../model/promocode.js"
import { usePromoCode } from "../model/campaign"
import { PromoCodeServiceFunction } from '../model/common.js';

import { dealResponsePriceValid } from './utils/deal.js';
import { validIsTeamMember } from './utils/utils.js';

const _PromoCode = PromoCodeServiceFunction()

import {router} from 'src/routes'
import { _Aso_Times } from '../model/_SealBigNumber.js';

const status = {
  'EXPIRE': 'The promo code has expired, please select the promo code to use again.',
  'REACH_LIMIT': 'The code usage limit has been reached.',
  'BAD_PRICE': 'The Promo code does not meet the requirements for the use.',
  'INVALID': 'Invalid promo code.',
}


// 应用状态
const state = () => {
  return {
    loginInfo: { name: '朱占伟' },
    serviceInfo: {}, // services info
    serviceType: '',
    step: '', // app,step2,...,plan
    app: {
      platform: 1,
      appId: '',
      region: ''
    },
    orderId: '',
    appInfo: null,
    campaignType: 'PACKAGE',
    asoServiceType:1,
    allPrices: null,
    oldPrices: null,
    orderActivity: null,
    packageInstall: null,
    keywordInstall: null,
    ratingInstall: null,
    reviewInstall: null,
    likesInstall:null,//点赞页数据
    asoInstall: null,
    campaignInstall: null,
    keywordsCoverInstall: null, // 关键词覆盖数据
    asoServiceInstall:null,//aso service数据
    installServiceInstall:null,//install package服务数据
    apiServiceInstall:null,
    totalPrice: 0,
    needMoney: 0,
    inAddMoney: false,
    orderOptInfo: null,
    keywordsForApp: null,
    continueLoading: false,
    editOrder: null,
    termsDialog: null,
    lReviewsType:1,
    linkUrl:'',//点赞页链接
    linkUrlCheckFlag:false,
    linkInfo:{},
    isBlur:false,
    //当前正在操作的服务安装,type表示服务类型,可自定义.减少不必要的数据声明
    serviceInstall: null,
    isIosMoveBack: false,//IOS系统机型下滑动
    hasNotice:false,
    firstOrderInfo: false,
    asoServiceHasApp:false,//aso service是否有app
    installServiceType:1,//install type
    promoteKeyword: null, //My Keyword点击promote跳转时将当前行信息存储
    promoteJump:false, //判断页面是否是由promote跳转进入
    needJumpOrder: false,

    acquOrderId: null,

    //promocode
    newStepPrices: null,
    promoCode: {
      code: '',
      reward: null,
    },
    deduct: null,
    promoCodeList: {
      useList: [],
      unUseList: []
    },
  };
};

const toLowerPrice = (price) => {
  const keys = Object.keys(price)
  let n = keys.length
  const newObj = {}
  let key
  while (n--) {
    key = keys[n]
    newObj[key.toLowerCase()] = price[key]
  }
  return newObj
}

const makeOrder = function (ctx) {
  let price
  if(ctx.state.promoCode.code && ctx.state.newStepPrices.type !== 'protocol'){
    price = toLowerPrice(ctx.getters['oldPricesForCurrentPlatform'])
  } else {
    if(ctx.state.promoCode.type === 'ASO_SERVICE') {
      price = toLowerPrice(ctx.getters['newStepPriceNoFirstGetter'].price)
    } else {
      price = toLowerPrice(ctx.getters['newStepPriceGetter'].price)
    }
  }
  let order = {
    ...ctx.state.app,
    submitType: ctx.state.serviceType,
    days: [],
    installType: null,
    prices: price
  }
  switch (ctx.state.serviceType) {
    case 'DIRECT_INSTALL':
      order.submitType = 'PACKAGE'
      order.installType = ctx.state.packageInstall.delivery
      ctx.state.packageInstall.list.forEach(e => {
        order.days.push([
          {
            'word': 'PACKAGE',
            'count': e.install
          }])
      })
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'DIRECT_INSTALL'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    case 'KEYWORD_INSTALL':
      order.submitType = 'KEYWORD'
      order.installType = ctx.state.keywordInstall.delivery
      if(ctx.state.acquOrderId && window.location.href.includes('isDialogJump')){
        order.acquOrderId = ctx.state.acquOrderId
        ctx.commit('clearAcquOrderId')
      }
      ctx.state.keywordInstall.list.forEach(day => {
        const oneDay = []
        day.forEach(d => {
          oneDay.push({
            'word': d.word,
            'count': parseInt(d.install)
          })
        })
        order.days.push(oneDay)
      })
      
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'KEYWORD_INSTALL'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    case 'RATING':
      order.submitType = 'RATE'
      order.installType = ctx.state.ratingInstall.delivery
      order.rateType = parseInt(ctx.state.ratingInstall.stars)
      order.rates = []
      ctx.state.ratingInstall.list.forEach(e => {
        order.rates.push(parseInt(e.install))
      })
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'RATING'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    case 'GUARANTEED_REVIEWS':
    case 'REVIEW':
      order.submitType = ctx.state.serviceType === 'GUARANTEED_REVIEWS' ? 'GREVIEW' : 'REVIEW'
      order.installType = ctx.state.reviewInstall.delivery
      order.rateType = parseInt(ctx.state.reviewInstall.stars)
      order.targetLanguage = ctx.state.reviewInstall.reviewLanguage
      order.titles = []
      order.contents = []
      order.reviewers = []
      ctx.state.reviewInstall.list.forEach(e => {
        if (e.isNull) {
          order.titles.push([])
          order.contents.push([])
          order.reviewers.push([])
          return
        }
        let title = [], content = [], reviewer = []
        if (!e.isNull) {
          e.review.forEach(i => {
            if (ctx.state.app.platform >= 2) {
              title.push(i.title)
              if(ctx.state.serviceType==='GUARANTEED_REVIEWS'){
                reviewer.push(i.reviewer)
              }
            }
            content.push(i.content)
          })
        }
        order.titles.push(title)
        order.contents.push(content)
        order.reviewers.push(reviewer)
      })
      order.contact = ctx.state.reviewInstall.contact
      if(ctx.state.promoCode.code && (ctx.state.promoCode.type === 'REVIEW' || ctx.state.promoCode.type === 'GUARANTEED_REVIEWS')){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    /*
    case 'GUARANTEED_REVIEWS':
      order.submitType = ctx.state.serviceType === 'GUARANTEED_REVIEWS' ? 'GREVIEW' : 'REVIEW'
      order.installType = ctx.state.reviewInstall.delivery
      order.rateType = parseInt(ctx.state.reviewInstall.stars)
      order.targetLanguage = ctx.state.reviewInstall.reviewLanguage
      order.titles = []
      order.contents = []
      order.reviewers = []
      ctx.state.reviewInstall.list.forEach(e => {
        if (ctx.state.app.platform >= 2) {
          order.titles.push(e.map(i => {
            return i.title
          }))
          if(ctx.state.serviceType==='GUARANTEED_REVIEWS'){ 
            order.reviewers.push(e.map(i => {
              return i.reviewer
            }))
          }
        }
        order.contents.push(e.map(i => {
          return i.content
        }))
      })
      order.contact = ctx.state.reviewInstall.contact
      if(ctx.state.promoCode.code && (ctx.state.promoCode.type === 'REVIEW' || ctx.state.promoCode.type === 'GUARANTEED_REVIEWS')){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = ctx.state.deduct - (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    */
    case 'CAMPAIGN':
    case 'SMART_CAMPAIGN':
    case 'INSTALLS_PACKAGE':{
      const currentServiceData = (ctx.state.serviceType === 'CAMPAIGN'||ctx.state.serviceType === 'SMART_CAMPAIGN') ? ctx.state.campaignInstall : ctx.state.installServiceInstall
      order.submitType =ctx.state.serviceType=== 'CAMPAIGN'?'COMPOSITE':'SMART'
      if(ctx.state.serviceType==='INSTALLS_PACKAGE'){
        order.submitType ='INSTALLS'
        order.installsPackageType = parseInt(ctx.state.installServiceType)
      }
      order.installType = currentServiceData.delivery
      order.rateType = parseInt(currentServiceData.stars)
      // packageInstall
      if (ctx.state.campaignType === 'PACKAGE') {
        currentServiceData.list.forEach(e => {
          order.days.push([
            {
              'word': 'PACKAGE',
              'count': parseInt(e.packageInstall)
            }])
        })
      } else {
        // keyword install
        currentServiceData.list.forEach(day => {
          const oneDay = []
          day.words.forEach(d => {
            oneDay.push({
              'word': d.word,
              'count': parseInt(d.install)
            })
          })
          order.days.push(oneDay)
        })
      }

      // rating
      order.rates = currentServiceData.list.map(i => parseInt(i.rating))
      // reviews
      order.targetLanguage = currentServiceData.reviewLanguage
      order.titles = []
      order.contents = []
      order.reviewers=[]
      currentServiceData.list.forEach(e => {
        if (ctx.state.app.platform >= 2) {
          order.titles.push(e.reviews.map(i => {
            return i.title
          }))
          if(ctx.state.serviceType==='INSTALLS_PACKAGE'){
            order.reviewers.push(e.reviews.map(i => {
              return i.reviewer
            }))
          }
        }
        order.contents.push(e.reviews.map(i => {
          return i.content
        }))
      })
      if(ctx.state.promoCode.code && (ctx.state.promoCode.type === 'CAMPAIGN' || ctx.state.promoCode.type === 'SMART_CAMPAIGN' || ctx.state.promoCode.type === 'INSTALLS_PACKAGE')){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break}
    case 'KEYWORD_RANKING_ACQUISITION':
      // order.submitType = 'KEYWORD_RANKING_ACQUISITION'
      var { contact, list } = ctx.state.keywordsCoverInstall
      list = list && list.filter((item) => item.word) || []
      var ps = ctx.getters.pricesForCurrentPlatform
      var p = list.length * ps['KEYWORD_ACQU']
      order = {
        ...ctx.state.app,
        contact: contact.contact,
        contactType: contact.contactType,
        orderPrice: p,
        wordList: list.map((item) => ({
          word: item.word
        }))
      }
      if (contact.contactType === 0) {
        order.contactDetail = contact.contactDetail
      }
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'KEYWORD_RANKING_ACQUISITION'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    case 'APP_REVIEWS_LIKES':
      order.submitType = 'LREVIEW'
      order.installType = ctx.state.likesInstall.delivery
      order.lReviews = []
      order.lReviewUrl = ctx.state.likesInstall.linkUrl
      order.lReviewsType = ctx.state.lReviewsType
      if (ctx.state.lReviewsType === 1 || ctx.state.lReviewsType === 2) {
        ctx.state.likesInstall.list.forEach(day => {
          order.lReviews.push(Number(day.install))
        })
      }
      break
    case 'ASO_SERVICE':
    //   order.message = ctx.state.asoServiceInstall.message
      Object.assign(order, ctx.state.asoServiceInstall.message)
      order.taskType = ctx.state.asoServiceType
      order.contact = ctx.state.asoServiceInstall.contact.contact
      order.contactType = ctx.state.asoServiceInstall.contact.contactType
      if (order.contactType === 0) {
        order.contactDetail = ctx.state.asoServiceInstall.contact.contactDetail
      }
      order.hasApp = ctx.state.asoServiceHasApp
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'ASO_SERVICE'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
    case 'API_SERVICES':
      order = {
        id: ctx.state.apiServiceInstall.id,
        now: ctx.state.apiServiceInstall.old === ctx.state.apiServiceInstall.now ? 2 : 1
      }
      if(ctx.state.promoCode.code && ctx.state.promoCode.type === 'API_SERVICES'){
        order.promoCode = ctx.state.promoCode.code,
        order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
      }
      break
  }
  let id = null
  if (ctx.state.editOrder) {
    id = ctx.state.editOrder._id
  }
  return { order: order, orderId: id }
}

const checkOrder = async function (ctx) {
  const checkRepeat = function (c, reviews,type=null) {
    let count = 0
    reviews.forEach(d => {
      if (d.title.trim() === c || d.content.trim() === c|| (d.reviewer&&d.reviewer.trim() === c)) {
        count++
        if (count >= 2) {
          return false
        }
      }
    })
    if (count >= 2) {
      if (type === 'website') {
        return 'Name of reviewer cannot be repeated'
      } else {
        return 'Do not repeat comments'
      }
    }
    return ''
  }
  const checkDay = function(list) {
    if (list.length > 14) {
      Dialog.alert({ message: `Orders are limited to a maximum of 14 days, please modify the days.` }, { showClose: false })
      return true
    }
    return false
  }
  // 检查各种表单
  switch (ctx.state.serviceType) {
    case 'DIRECT_INSTALL': {
      if (checkDay(ctx.state.packageInstall.list)) {
        return false
      }
      for (const i of ctx.state.packageInstall.list) {
        const error = inputInstallCountValidate(i.install)
        if (error) {
          await Dialog.alert({ message: `${error}` }, { showClose: false })
          return false
        }
      }
      let dayInstall = 0
      for (const i of ctx.state.packageInstall.list) {
        dayInstall = i.install
        const numError = installCountValidate(dayInstall)
        if (numError) {
          await Dialog.alert({ message: `${numError}`, confirmButtonText: "Ok" }, { showClose: false })
          return false
        }
      }
      break
    }
    case 'KEYWORD_INSTALL': {
      if (checkDay(ctx.state.keywordInstall.list)) {
        return false
      }
      for (const days of ctx.state.keywordInstall.list) {
        for (const i of days) {
          // 检查安装数量
          const error = inputInstallCountValidate(i.install)
          if (error) {
            await Dialog.alert({ message: `Install count error: ${error}` }, { showClose: false })
            return false
          }
          // 检查关键词不为空且不重复
          const w = i.word.trim()
          if (w.length === 0) {
            await Dialog.alert({ message: 'Keyword cannot be empty' }, { showClose: false })
            return false
          } else if (days.filter(i => w.trim().toLowerCase() ===
            i.word.trim().toLowerCase()).length > 1) {
            await Dialog.alert({ message: 'Keywords cannot be repeated' }, { showClose: false })
            return false
          }
          // 检查关键词已获取排名掉榜
          if (i.rank != null && i.rank <= 0 && ctx.state.app.platform>=2) {
            await Dialog.alert({ message: 'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us. ' }, { showClose: false })
            return false
          }
        }
      }
      for (const days of ctx.state.keywordInstall.list) {
        let dayInstall = 0
        for (const i of days) {
          dayInstall += i.install
        }
        // 检查安装数量
        const numError = installCountValidate(dayInstall)
        if (numError) {
          await Dialog.alert({ message: `${numError}`, confirmButtonText: "Ok" }, { showClose: false })
          return false
        }
      }
      break
    }
    case 'RATING': {
      if (checkDay(ctx.state.ratingInstall.list)) {
        return false
      }
      for (const i of ctx.state.ratingInstall.list) {
        const error = inputInstallCountValidate(i.install)
        if (error) {
          await Dialog.alert({ message: `${error}` }, { showClose: false })
          return false
        }
      }
      break
    }
    case 'GUARANTEED_REVIEWS':
    case 'REVIEW':  {
      if (checkDay(ctx.state.reviewInstall.list)) {
        return false
      }
      if (ctx.state.serviceType === 'GUARANTEED_REVIEWS'&&ctx.state.app.platform===1) {
        const totalCount = _.sumBy(ctx.state.reviewInstall.list, (i) => {
          if (i.isNull) {
            return 0
          }
          return i.review.length
        })
        if (totalCount < 10) {
          await Dialog.alert({ message: 'The minimum number of your reviews is 10.' })
          return false
        }
      }
      for (const days of ctx.state.reviewInstall.list) {
        if (days.isNull) continue;
        let daysList = days.review
        for (const i of daysList) {
          if (ctx.state.app.platform >= 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Title cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({ message: repeat })
                return false
              }
            }
  
            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
            if(ctx.state.serviceType === 'GUARANTEED_REVIEWS'){
              c = i.reviewer.trim()
              if(c.length>0){
                if(c.length<12){
                  await Dialog.alert({ message: `Name of reviewer is limited to 12-25 characters` }, { showClose: false })
                  return false
                }
                if(isWebsite(c)){
                  await Dialog.alert({ message: `Name of reviewer is not available` }, { showClose: false })
                  return false
                }
                const repeat = checkRepeat(c, daysList,'website')
                if (repeat) {
                  await Dialog.alert({ message: repeat }, { showClose: false })
                  return false
                }
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
          }
        }
      }
      //save时敏感词提示逻辑
      if(ctx.state.app.platform>=2&&ctx.state.reviewInstall.list.find(item=>item.review.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
        // 是否有敏感词
        await Dialog.alert({ message: `Reviews or titles contain the word that is advised not to use.Please check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
        return false
      }
      break
    }
    /*
    case 'GUARANTEED_REVIEWS': {
      if (checkDay(ctx.state.reviewInstall.list)) {
        return false
      }
      if (ctx.state.serviceType === 'GUARANTEED_REVIEWS'&&ctx.state.app.platform===1) {
        const totalCount = _.sumBy(ctx.state.reviewInstall.list, (i) => i.length)
        if (totalCount < 10) {
          await Dialog.alert({ message: 'The minimum number of your reviews is 10.' })
          return false
        }
      }
      for (const days of ctx.state.reviewInstall.list) {
        for (const i of days) {
          if (ctx.state.app.platform >= 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Title cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({ message: repeat })
                return false
              }
            }

            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
            if(ctx.state.serviceType === 'GUARANTEED_REVIEWS'){
              c = i.reviewer.trim()
              if(c.length>0){
                if(c.length<12){
                  await Dialog.alert({ message: `Name of reviewer is limited to 12-25 characters` }, { showClose: false })
                  return false
                }
                if(isWebsite(c)){
                  await Dialog.alert({ message: `Name of reviewer is not available` }, { showClose: false })
                  return false
                }
                const repeat = checkRepeat(c, days,'website')
                if (repeat) {
                  await Dialog.alert({ message: repeat }, { showClose: false })
                  return false
                }
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
          }
        }
      }
      //save时敏感词提示逻辑
      if(ctx.state.app.platform>=2&&ctx.state.reviewInstall.list.find(item=>item.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
        // 是否有敏感词
        await Dialog.alert({ message: `Reviews or titles contain the word that is advised not to use.Please check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
        return false
      }
      break
    }
    */
    case 'ASO': {
      let skipOutCheck = false // 如果用户第一次选择了对out的词继续提交，则后续都需要跳过out检查
      for (const i of ctx.state.asoInstall.list) {
        // 检查关键词不为空且不重复
        const w = i.word.trim()
        if (w.length === 0) {
          await Dialog.alert({
            message: 'Keyword cannot be empty'
          }, { showClose: false })
          return false
        } else if (ctx.state.asoInstall.list.filter(
          i => w.trim().toLowerCase() ===
            i.word.trim().toLowerCase()).length > 1) {
          await Dialog.alert({ message: 'Keywords cannot be repeated' }, { showClose: false })
          return false
        }
        // 检查关键词已获取排名掉榜
        if (!skipOutCheck && i.rank != null && i.rank <= 0 && ctx.state.app.platform>=2) {
          try {
            await Dialog.confirm({
              message: 'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us.'
            }, {
              confirmButtonText: 'Continue Submit',
              cancelButtonText: 'Cancel'
            })
            skipOutCheck = true
          } catch (e) {
            return false
          }
        }
      }
      if(!(ctx.state.asoInstall.contact.contactType || ctx.state.asoInstall.contact.contactType===0)) {
        await Dialog.alert({
          message: 'Contact type cannot be empty'
        }, { showClose: false })
        return false
      }
      if(ctx.state.asoInstall.contact.contactType === 0 && ctx.state.asoInstall.contact.contactDetail.trim().length <= 0) {
        await Dialog.alert({
          message: 'WhatsApp Code cannot be empty'
        }, { showClose: false })
        return false
      }
      if(ctx.state.asoInstall.contact.contact.trim().length <= 0) {
        await Dialog.alert({
          message: 'Contact cannot be empty'
        }, { showClose: false })
        return false
      }
      break
    }
    case 'CAMPAIGN':
    case 'SMART_CAMPAIGN':
    case 'INSTALLS_PACKAGE':
    {
      const currentServiceData = (ctx.state.serviceType === 'CAMPAIGN'||ctx.state.serviceType === 'SMART_CAMPAIGN') ? ctx.state.campaignInstall : ctx.state.installServiceInstall
      if (checkDay(currentServiceData)) {
        return false
      }
      const installsPerDay = [] // 每天的安装数量，用于后续检查
      if (ctx.state.campaignType === 'PACKAGE') {
        // 检查package install 数量正确
        for (const i of currentServiceData.list) {
          installsPerDay.push(i.packageInstall)
          const error = inputInstallCountValidate(i.packageInstall)
          if (error) {
            await Dialog.alert({
              message: `${error}`
            }, { showClose: false })
            return false
          }
        }
        if (ctx.state.serviceType === 'CAMPAIGN'||ctx.state.serviceType === 'SMART_CAMPAIGN') {
          let dayInstall = 0
          for (const i of currentServiceData.list) {
            dayInstall = i.packageInstall
            const numError = installCountValidate(dayInstall)
            if (numError) {
              await Dialog.alert({
                message: `${numError}`, confirmButtonText: "Ok"
              }, { showClose: false })
              return false
            }
          }
        }
      } else if (ctx.state.campaignType === 'KEYWORD') {
        // 智能投放部分首次不赋值 不进入下面循环
        if(!currentServiceData?.list) {
          await Dialog.alert({ message: 'Keyword cannot be empty' }, { showClose: false })
          return false
        }
        // 检查每天关键词不重复，且数量正确
        for (const days of currentServiceData.list) {
          let installToday = 0
          for (const i of days.words) {
            // 检查安装数量
            const error = inputInstallCountValidate(i.install)
            if (error) {
              await Dialog.alert({ message: `Install count error: ${error}` }, { showClose: false })
              return false
            }
            installToday += i.install
            // 检查关键词不为空且不重复
            const w = i.word.trim()
            if (w.length === 0) {
              await Dialog.alert({ message: 'Keyword cannot be empty' }, { showClose: false })
              return false
            } else if (days.words.filter(i => w.trim().toLowerCase() ===
              i.word.trim().toLowerCase()).length > 1) {
              await Dialog.alert({ message: 'Keywords cannot be repeated' }, { showClose: false })
              return false
            }
            // 检查关键词已获取排名掉榜
            if (i.rank != null && i.rank <= 0 && ctx.state.app.platform>=2) {
              await Dialog.alert({ message: 'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us. ' }, { showClose: false })
              return false
            }
          }
          installsPerDay.push(installToday)
        }
        if (ctx.state.serviceType === 'CAMPAIGN'||ctx.state.serviceType === 'SMART_CAMPAIGN') {
          for (const days of currentServiceData.list) {
            let dayInstall = 0
            for (const i of days.words) {
              dayInstall += parseInt(i.install)
            }
            const errorNum = installCountValidate(dayInstall)
            if (errorNum) {
              await Dialog.alert({
                message: `${errorNum}`, confirmButtonText: "Ok"
              }, { showClose: false })
              return false
            }
          }
        }
      }
      const totalInstall = _.sum(installsPerDay)
      // 检查每天评分数量合法且小于安装数
      let totalRating = 0
      let index = 0
      for (const i of currentServiceData.list) {
        const error = inputInstallCountValidate(parseInt(i.rating), -1)
        totalRating += parseInt(i.rating)
        if (error) {
          await Dialog.alert({ message: `${error}`, showClose: false })
          return false
        }
        if (parseInt(i.rating) > installsPerDay[index]) {
          await Dialog.alert({ message: `The number of ratings must be less than or equal to the number of installs` }, { showClose: false })
          return false
        }
        index++
      }
      // 检查每天评论数量小于评分数量
      for (const i of currentServiceData.list) {
        if (i.reviews.length > parseInt(i.rating)) {
          await Dialog.alert({ message: `The number of reviews must be less than or equal to the number of ratings` }, { showClose: false })
          return false
        }
      }
      // 检查每天评语不重复
      let totalReviews = 0
      for (const days of currentServiceData.list) {
        totalReviews += days.reviews.length
        for (const i of days.reviews) {
          if (ctx.state.app.platform >= 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Title cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }

            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
            
            if (ctx.state.serviceType === 'INSTALLS_PACKAGE') {
              c = i.reviewer.trim()
              if ((c.length>0&&c.length < 12)||c.length>25) { 
                await Dialog.alert({message:`Name of reviewer is limited to 12-25 characters`}, { showClose: false })
                return false
              }
              if (c.length>0&&isWebsite(c)) {
                await Dialog.alert({message:`Name of reviewer is not available`}, { showClose: false })
                return false
              }
              const repeat = checkRepeat(c, days.reviews,'website')
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({ message: repeat }, { showClose: false })
                return false
              }
            }
          }
        }
      }
      // 对于gp，评分/安装，评论/安装小于一定值，强制弹出确认条款
      if (ctx.state.app.platform === 1 && totalRating / totalInstall > 0.15 || totalReviews / totalInstall > 0.05) {
        if (ctx.state.termsDialog) {
          try {
            await ctx.state.termsDialog()
          } catch (e) {
            return
          }
        }
      }
      // // 对于ios，目前需要对有评分评论的弹出框确认
      // if (ctx.state.app.platform === 2 && totalRating > 0) {
      //   if (ctx.state.termsDialog) {
      //     try {
      //       await ctx.state.termsDialog()
      //     } catch (e) {
      //       return
      //     }
      //   }
      // }
      //save时敏感词提示逻辑
      // if(ctx.state.app.platform===2&&currentServiceData.list.find(item=>item.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
      //   // 是否有敏感词
      //   await Dialog.alert({ message: `Reviews or titles contain the offensive word.\nPlease check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
      //   return false
      // }
      break
    }
    // 点赞页表单校验
    case 'APP_REVIEWS_LIKES': {
      const lReviewUrl = ctx.state.likesInstall.linkUrl.trim()
      if (lReviewUrl.length === 0) {
        await Dialog.alert({ message: `Content cannot be empty` }, { showClose: false })
        return false
      } else {
        if (ctx.state.linkUrlCheckFlag) {
          await Dialog.alert({message:`The URL entered is not recognized`}, { showClose: false })
          return false
        }
      }
      if (checkDay(ctx.state.likesInstall.list)) {
        return false
      }
      for (const i of ctx.state.likesInstall.list) {
        const error = inputInstallCountValidate(i.install)
        if (error) {
          await Dialog.alert({ message: `${error}`},{ showClose: false })
          return false
        }
      }
      break
    }
    case 'KEYWORD_RANKING_ACQUISITION': {
      const list = ctx.state.keywordsCoverInstall.list
      let skipOutCheck = false // 如果用户第一次选择了对out的词继续提交，则后续都需要跳过out检查
      if(!(ctx.state.keywordsCoverInstall.contact.contactType || ctx.state.keywordsCoverInstall.contact.contactType===0)) {
        await Dialog.alert({
          message: 'Contact type cannot be empty'
        }, { showClose: false })
        return false
      }
      if(ctx.state.keywordsCoverInstall.contact.contactType === 0 && ctx.state.keywordsCoverInstall.contact.contactDetail.trim().length <= 0) {
        await Dialog.alert({
          message: 'WhatsApp Code cannot be empty'
        }, { showClose: false })
        return false
      }
      if(ctx.state.keywordsCoverInstall.contact.contact.trim().length <= 0){
        await Dialog.alert({ message:'Contact cannot be empty' }, { showClose: false })
        return 
      }
      for (const i of list) {
        // 检查关键词不为空且不重复
        const w = i.word.trim()
        if (w.length === 0) {
          await Dialog.alert({ message:'Keyword cannot be empty' }, { showClose: false })
          return false
        } else if (list.filter(
          i => w.trim().toLowerCase() ===
            i.word.trim().toLowerCase()).length > 1) {
          await Dialog.alert({ message:'Keywords cannot be repeated' }, { showClose: false })
          return false
        }
        
        // 检查关键词已获取排名掉榜
        if (!skipOutCheck && i.rank != null && i.rank > 0) {
          try {
            Dialog.confirm({
              allowHtml: true,
              message: `This keyword has been ranked already,place the <span onclick='window.goKeyword(${JSON.stringify(i)})' class="hover" style='color:#6153FF'>keyword installs</span>
              order can increase your app's searching ranking.
           `,
              showConfirmButton: false,
              cancelButtonText: 'Cancel',
            }).then(() => {
              skipOutCheck = true
            }).catch(() => {
              // console.log("取消")
            })



      
            skipOutCheck = true
            return false



          } catch (e) {
            return false
          }
        }
      }
      break
    }
  }
  return true
}

/**
 * @Date: 2021-10-20 14:07:25
 * @LastEditTime:
 * @description: 创建ASO服务订单
 * @param {*} state vue的 state对象
 * @return {*}
 */
const createASOOrder = async function (state) {
  const wannas = state.asoInstall.list.map(i => {
    return {
      'top': Number(i.top),
      'word': i.word
    }
  })
  const p = {
    orderId: state.editOrder ? state.editOrder._id : null,
    order: {
      ...state.app,
      'wordList': wannas,
      'contact': state.asoInstall.contact.contact,
      contactType: state.asoInstall.contact.contactType
    }
  }
  
  if(state.asoInstall.contact.contactType===0){
    p.order.contactDetail = state.asoInstall.contact.contactDetail
  }
  const res = await post('/MyPurpose/createPurpose', p)
  return res
}

/**
 * @Date: 2021-10-20 14:07:25
 * @LastEditTime:
 * @description: 创建关键词覆盖服务订单
 * @param {*} state vue的 state对象
 * @return {*}
 */
const createKeyWordsCoverOrder = async function (ctx) {
  try {
    const params = makeOrder(ctx)
    if (params.order.wordList && !params.order.wordList.length) {
      this.$message.warning('Keyword cannot be empty')
      return null
    }
    const res = await post('/MyKeywordAcqu/createOrder', params)
    return res
  } catch (error) {
    return Promise.resolve(null)
  }
}
// 创建aso service订单
const createAsoServiceOrder = async function(ctx) {
  try {
    if(ctx.state.asoServiceInstall.contact.contactType === 0 && ctx.state.asoServiceInstall.contact.contactDetail.trim().length <= 0) {
      await Dialog.alert({
        message: 'WhatsApp Code cannot be empty'
      }, { showClose: false })
      return false
    }
    const params = makeOrder(ctx)
    const res = await post('/MyAsoService/createAsoService', params)
    return res
  } catch (error) {
    return Promise.resolve(null)
  }
}
//智能投放下单时添加关键词
const smartAddKeywords = async function (ctx) {
  const orderInfo = makeOrder(ctx).order
  const daysList = orderInfo.days
  const keywordList = []
  daysList.forEach(item => {
    item.forEach(data => {
      if (!keywordList.includes(data.word)) {
        keywordList.push(data.word)
      }
    })
  })
  // 添加词到MyKeywords
  await post('/MyKeyword/addKeyWord', {
    appId: orderInfo.appId,
    region: orderInfo.region,
    platform: orderInfo.platform,
    words: [...keywordList]
  })
}


// getters
const getters = {
  firstOrderOffDesc: s => {
    if (s.orderActivity.length) {
      const firstOrderActivity = s.orderActivity.find(i => {
        return i.type === 3
      })
      if (firstOrderActivity) {
        return firstOrderActivity.detail.desc
      }
    }
    return ''
  },
  pricesForCurrentPlatform: s => {
    return s.allPrices && s.allPrices[s.app.platform === 1 ? 'Google' : 'Apple']
  },
  oldPricesForCurrentPlatform: s => {
    return s.oldPrices && s.oldPrices[s.app.platform === 1 ? 'Google' : 'Apple']
  },
  orderOptForCurrentPlatform: s => {
    return s.orderOptInfo && s.orderOptInfo.find(e => e.platform === s.app.platform)
  },
  pricesForCurrentPlatformLowcase: s => {
    const ret = s.allPrices[s.app.platform === 1 ? 'Google' : 'Apple']
    const keys = Object.keys(ret)
    let n = keys.length
    const newObj = {}
    let key
    while (n--) {
      key = keys[n]
      newObj[key.toLowerCase()] = ret[key]
    }
    return newObj
  },
  newStepPriceGetter: s => {
    let price, type
    const stepPrice = s.newStepPrices
    if(stepPrice){
      if (stepPrice.protocolPrice) {
        price = stepPrice.protocolPrice[s.app.platform === 1 ? 'Google' : 'Apple']
        type = 'protocol'
      } else if (stepPrice.activityPrice) {
        price = stepPrice.activityPrice[s.app.platform === 1 ? 'Google' : 'Apple']
        type = 'active'
      } else if (stepPrice.memberPrice) {
        price = stepPrice.memberPrice[s.app.platform === 1 ? 'Google' : 'Apple']
        type = 'member'
      }
    }
    return {
      price, type
    }
  },
  newStepPriceNoFirstGetter: s => {
    let price, type
    const stepPrice = s.newStepPrices
    if(stepPrice){
      if (stepPrice.protocolPrice) {
        price = stepPrice.protocolPrice[s.app.platform === 1 ? 'Google' : 'Apple']
        type = 'protocol'
      } else if (stepPrice.memberPrice) {
        price = stepPrice.memberPrice[s.app.platform === 1 ? 'Google' : 'Apple']
        type = 'member'
      }
    }
    return {
      price, type
    }
  }
}
// 操作管理
const mutations = {
  //清空下单数据
  clearOrder(s){
    s.campaignInstall = null
    s.packageInstall = null
    s.keywordsCoverInstall = null
    s.asoInstall = null
    s.likesInstall = null
    s.reviewInstall = null
    s.ratingInstall = null
    s.keywordInstall = null
  },
  // 设置首单用户提示
  setFirstOrderInfo(s, payload) {
    s.firstOrderInfo = payload
  },
  //检测首页是否弹出警告
  sethasNotice(s,payload){
    s.hasNotice = payload
  },
  // 服务安装添加数据
  setServiceInstall(s,payload){
    s.serviceInstall = {...s.serviceInstall,...payload}
  },
  // 服务安装添加数据直接全部赋值
  setServiceInstallDirect(s,payload){
    s.serviceInstall =  payload
  },
  // 设置关键词覆盖数据
  setKeywordsCoverInstall(s, payload) {
    s.keywordsCoverInstall = JSON.parse(JSON.stringify(payload))
  },
  // 清除所有状态
  clear(s) {
    s.serviceType = ''
    s.step = ''
    s.app = {
      platform: 1,
      appId: '',
      region: ''
    }
    s.showReviewAlert = false
  },
  setEditOrder(s, payload) {
    s.editOrder = payload
  },
  setSingleOptInfo(s, payload) {
    s.serviceInfo = payload
  },
  // 选中服务类型
  selectServiceType(s, type) {
    s.serviceType = type
    s.step = 'app'
  },
  setStep(s, step) {
    s.step = step
  },
  // 选中app
  setApp(s, payload) {
    s.app.platform = payload.basic.platform
    s.app.appId = payload.basic.appId
    s.app.region = payload.basic.region
    if (payload.appInfo) {
      s.appInfo = { ...payload.appInfo }
    } else {
      s.appInfo = null
    }
  },
  setAllPrices(s, payload) {
    s.allPrices = JSON.parse(JSON.stringify(payload.data))
  },
  setOldPrices(s, payload) {
    s.oldPrices = JSON.parse(JSON.stringify(payload.data))
  },
  setPackageInstall(s, payload) {
    s.packageInstall = JSON.parse(JSON.stringify(payload))
  },
  setKeywordInstall(s, payload) {
    s.keywordInstall = JSON.parse(JSON.stringify(payload))
  },
  setRatingInstall(s, payload) {
    s.ratingInstall = JSON.parse(JSON.stringify(payload))
  },
  setReviewInstall(s, payload) {
    s.reviewInstall = JSON.parse(JSON.stringify(payload))
  },
  setAsoInstall(s, payload) {
    s.asoInstall = JSON.parse(JSON.stringify(payload))
  },
  setCampaignInstall(s, v) {
    s.campaignInstall = JSON.parse(JSON.stringify(v))
  },
  setAsoServiceInstall(s, v){
    s.asoServiceInstall=JSON.parse(JSON.stringify(v))
  },
  setInstallServiceInstall(s, v){
    s.installServiceInstall=JSON.parse(JSON.stringify(v))
  },
  setTotalPrice(s, p) {
    s.totalPrice = p
  },
  setNeedMoney(s, need) {
    s.needMoney = need
  },
  setInAddMoney(s, v) {
    s.inAddMoney = v
  },
  setOrderOptInfo(s, v) {
    s.orderOptInfo = v
  },
  setKeywordForApp(s, v) {
    s.keywordsForApp = v
  },
  setCampaignType(s, v) {
    s.campaignType = v
  },
  setAsoServiceType(s, v) {
    s.asoServiceType = v
  },
  setInstallServiceType(s, v) {
    s.installServiceType = v
  },
  setOrderActivity(s, v) {
    s.orderActivity = JSON.parse(JSON.stringify(v?.data ?? []))
  },
  setContinueLoading(s, v) {
    s.continueLoading = v
  },
  //设置点赞还是点踩
  setlReviewsType(s, v) {
    s.lReviewsType = v
  },
  setTermsDialog(s, v) {
    s.termsDialog = v
  },
  setOrderId(s, v) {
    s.orderId = v
  },
  // 设置点赞页数据
  setLikesInstall(s, payload) {
    s.likesInstall = JSON.parse(JSON.stringify(payload))
  },
  //设置点赞页的链接
  setLinkUrl(s, v) {
    s.linkUrl = v
  },
  //设置校验结果
  setCheckFlag(s, v) {
    s.linkUrlCheckFlag = v
  },
  //设置校验信息
  setValidateInfo(s,v){
    s.linkInfo = JSON.parse(JSON.stringify(v))
  },
  //设置loading，数据回显时进入校验状态
  setIsBlur(s, v) {
    s.isBlur=v
  },
  //设置是否ios左右滑动
  setIsIosMoveBack (s, v) {
    s.isIosMoveBack = v
  },
  setServiceHasApp(s,v){
    s.asoServiceHasApp=v
  },
  setPromote(s,v){
    s.promoteKeyword = JSON.parse(JSON.stringify(v))
  },
  setPromoteJump(s,v){
    s.promoteJump = v
  },
  setNeedJumpOrder(s,v){
    s.needJumpOrder = v
  },
  setAPIService(s,v){
    s.apiServiceInstall = v
  },
  setAcquOrderId(s,v) {
    s.acquOrderId = v
  },
  setPromoList(s,v) {
    s.promoCodeList = v
  },
  setPromoCode(s,v) {
    s.promoCode = v
  },
  setNewStepPrices(s,v) {
    s.newStepPrices = v
  },
  setDeductPrice(s,v) {
    s.deduct = v
  },
  clearAcquOrderId(s) {
    s.acquOrderId = null
  }
};
// 可异步操作
const actions = {
  clear() {
    this._vm.$confirm('Are your sure to discard?', 'Confirm', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(() => {
      // ctx.commit('clear')
      window.location.replace('/wap/home')
    }).catch(() => {
    })
  },
  async getOrderPrecondition(ctx) {
    const apis = []
    apis.push(
      // 获取价格
      new Promise(async (r, j) => {
        const res =ctx.state.serviceType==='ASO_SERVICE'? await post('MyOrder/getAsoServicePrices', {
          region:ctx.state.app.region
        }): await post('MyOrder/getPrices', {
          ...ctx.state.app
        })
        if (res) {
          ctx.commit('setAllPrices', res)
          r()
        } else {
          j()
        }
      }),
      // 获取原来价格
      new Promise(async (r, j) => {
        const res = await post('MyOrder/getNoActivityPrices', {
          ...ctx.state.app
        })
        if (res) {
          ctx.commit('setOldPrices', res)
          r()
        } else {
          j()
        }
      }),
      // 获取订单服务设置(评论是否开启)
      new Promise(async (r, j) => {
        const res = await post('MyOrderOpt/getOrderOptInfo')
        if (res) {
          ctx.commit('setOrderOptInfo', res.data)
          r()
        } else {
          j()
        }
      }),
      // 获取活动
      new Promise(async (r, j) => {
        const res = await post('MyActivity/getMatchActivityWhenCalcPrice', {
          ...ctx.state.app
        })
        if (res) {
          ctx.commit('setOrderActivity', res)
          r()
        } else {
          j()
        }
      }),
      // 获取新活动
      new Promise(async (r, j) => {
        const res = await post('MyOrder/getStepPrices', {
          ...ctx.state.app
        })
        if (res && res.code === 0) {
          ctx.commit('setNewStepPrices', res.data)
          r()
        } else {
          j()
        }
      })
    )
    // 获取关键词
    if (ctx.state.serviceType === 'KEYWORD_INSTALL' || ctx.state.serviceType ===
      'CAMPAIGN' || ctx.state.serviceType === 'ASO') {
      apis.push(new Promise(async (r, j) => {
        const res = await post('MyKeyword/listWords', {
          ...ctx.state.app,
          'topOnly': false
        })
        if (res && res.data) {
          const list = _.map(res.data.list, i => {
            return i.word
          })
          ctx.commit('setKeywordForApp', list)
          r()
        } else {
          j()
        }
      }))
    }
    await Promise.all(apis)
  },

  async gotoPromote(ctx) {
    // 检查app
    if (ctx.state.asoServiceHasApp || ctx.state.serviceType !== 'ASO_SERVICE') {
      const appInfo = ctx.state.appInfo
      if (!appInfo) {
        await Dialog.alert({
          message: 'Choose an application first',
        })
        return
      }
      // 由于下架判断有问题，这里先移除
      // if (!appInfo.appInfo.isOnline) {
      //   await Dialog.alert(
      //     'Application with this package name or id wasn\'t found in the appstore in the selected region. Find it in the store manually, double check region selection and in case it exists, please contact support.',
      //     { showClose: false })
      //   return
      // }
      if (!appInfo.appInfo.isFree) {
        await Dialog.alert({
          message: 'This is paid application, unfortunately we can\'t promote paid apps.'
        },
        { showClose: false })
        return
      }
    }
    ctx.commit('setContinueLoading', true)
    await ctx.dispatch('getOrderPrecondition')
    ctx.commit('setContinueLoading', false)
    ctx.commit('setStep', 'plan')
  },
  async saveDraftConfirm(ctx) {
    await post('/Tracking/eventTrack', {
      id: window.$mine.id,
      modules: 'SERVICES',
      clickTime: new Date().getTime(),
      serviceName: getTrackServiceName(ctx.state.serviceType),
      operationType: 'CLICK',
      op: 'save',
      deviceType: isMobile() ? 2 : 1,
      url: '/wap/campaign'
    })
    // 保存订单
    Dialog.confirm({ message: 'Are you sure to save the order?' }).then(async () => {
      let apiPath = 'MyOrder/addOrder'
      const maker_order = makeOrder(ctx)
      const res = await post(apiPath, { ...maker_order, order: { ...maker_order.order, origin: 0 }})
      if (res) {
        if (res.code !== 0||res.data.error) {
          await Dialog.alert({
            message: res.msg||res.data.error
          }, { showClose: false })
          await ctx.dispatch('getOrderPrecondition')// 出现诸如价格变动等错误后，重新刷新订单前置条件
        } else {
          // window.location.replace('/wap/home')
          // ctx.dispatch('user/getBalance', {}, { root: true })
          // router.push('/wap/home?orderId='+res.data.id)
          if (ctx.state.serviceType === 'SMART_CAMPAIGN') {
            await smartAddKeywords(ctx)
          }
          await post('/Tracking/eventTrack', {
            id: window.$mine.id,
            modules: 'SERVICES',
            clickTime: new Date().getTime(),
            serviceName: getTrackServiceName(ctx.state.serviceType),
            operationType: 'CLICK',
            op: 'save_ok',
            deviceType: isMobile() ? 2 : 1,
            url: '/wap/campaign'
          })
          if (router.currentRoute.value.query.openType === 'userGuidanceDialog' && ctx.state.serviceType === 'KEYWORD_INSTALL') {
            router.push({
              name: 'dashboard',
              params: {
                openUserGuidanceDialog: true
              }
            })
          } else {
            router.push('/wap/order')
          }
        }
      }
    }).catch(async() => {
      await post('/Tracking/eventTrack', {
        id: window.$mine.id,
        modules: 'SERVICES',
        clickTime: new Date().getTime(),
        serviceName: getTrackServiceName(ctx.state.serviceType),
        operationType: 'CLICK',
        op: 'save_cancel',
        deviceType: isMobile() ? 2 : 1,
        url: '/wap/campaign'
      })
    })
  },
  async saveDraftConfirmBeforePro(ctx) {
    await post('/Tracking/eventTrack', {
      id: window.$mine.id,
      modules: 'SERVICES',
      clickTime: new Date().getTime(),
      serviceName: getTrackServiceName(ctx.state.serviceType),
      operationType: 'CLICK',
      op: 'save',
      deviceType: isMobile() ? 2 : 1,
      url: '/wap/campaign'
    })
    // 保存订单
    let apiPath = 'MyOrder/addOrder'
    const maker_order = makeOrder(ctx)
    const res = await post(apiPath, { ...maker_order, order: { ...maker_order.order, origin: 0 }})
    console.log('here')
    ctx.commit('clearAcquOrderId')
    if (res) {
      if (res.code !== 0||res.data.error) {
        await Dialog.alert({
          message: res.msg||res.data.error
        }, { showClose: false })
        await ctx.dispatch('getOrderPrecondition')// 出现诸如价格变动等错误后，重新刷新订单前置条件
      } else {
        // window.location.replace('/wap/home')
        // ctx.dispatch('user/getBalance', {}, { root: true })
        // router.push('/wap/home?orderId='+res.data.id)
        if (ctx.state.serviceType === 'SMART_CAMPAIGN') {
          await smartAddKeywords(ctx)
        }
        await post('/Tracking/eventTrack', {
          id: window.$mine.id,
          modules: 'SERVICES',
          clickTime: new Date().getTime(),
          serviceName: getTrackServiceName(ctx.state.serviceType),
          operationType: 'CLICK',
          op: 'save_ok',
          deviceType: isMobile() ? 2 : 1,
          url: '/wap/campaign'
        })
        // router.push('/wap/order')
      }
    }
  },
  async saveDraft(ctx){
    if (!(await checkOrder(ctx))) {
      return
    }
    if(ctx.getters.orderOptForCurrentPlatform && ctx.getters.orderOptForCurrentPlatform.warnings
      &&(ctx.state.serviceType==='RATING'||ctx.state.serviceType==='REVIEW'||ctx.state.serviceType==='GUARANTEED_REVIEWS'||ctx.state.serviceType==='CAMPAIGN'||ctx.state.serviceType==='SMART_CAMPAIGN')
    ){
      // 保存订单
      Dialog.confirm({ allowHtml: true,message: ctx.getters.orderOptForCurrentPlatform&& ctx.getters.orderOptForCurrentPlatform.warningsTips,className:'terms-dialog' }).then(async () => {
        await ctx.dispatch('saveDraftConfirm')
      }).catch(() => {
        
      })
    }else{
      await ctx.dispatch('saveDraftConfirm')
    }
  },
  async startPromoteConfirm(ctx) {
    // 检查激活
    try {
      await ctx.dispatch('user/triggerActive', {}, { root: true })
    } catch (e) {
      return
    }
    
    const { serviceType, totalPrice } = ctx.state
    const isTeamMember = validIsTeamMember()

    const validParams = {
      params: {
        serviceType,
        total: _Aso_Times(totalPrice, 100, 2),
        team: true,
        account:true
      },
      func: {
        getBalance: () => { return ctx.rootState.user.balance ? Number(ctx.rootState.user.balance) : 0 },
        refreshBalance: async () => { await ctx.dispatch('user/getBalance', {}, { root: true })  },
        setNeedMoney: need => { ctx.commit('setNeedMoney', need) },
        setInAddMoney: () => { ctx.commit('setInAddMoney', true) },
        saveDraftbeforePro: async() => { await ctx.dispatch('saveDraftConfirmBeforePro') },
        setNeedJumpOrder: async () => { ctx.commit('setNeedJumpOrder', true) }
      }
    }


    const types = ['ASO', 'KEYWORD_RANKING_ACQUISITION']
    // 创建订单流程【1.不需要检查余额 2.检查余额】


    if (types.includes(serviceType)) {
      // 是否是关键词覆盖
      const isKwCover = serviceType === 'KEYWORD_RANKING_ACQUISITION'
      // 回调路径
      let path = '/wap/home'
      let res = null

      // 创建ASO订单
      if (serviceType === 'ASO') {
        res = await createASOOrder.call(this._vm, ctx.state)
        path='/wap/order?type=guaranteed'
        if (res) {
          await Dialog.alert({
            message: 'We have received your order and will contact you within 24h.'
          },
          { showClose: false })
          await post('/Tracking/eventTrack', {
            id: window.$mine.id,
            modules: 'SERVICES',
            clickTime: new Date().getTime(),
            serviceName: getTrackServiceName(ctx.state.serviceType),
            operationType: 'CLICK',
            op: 'submit',
            deviceType: isMobile() ? 2 : 1,
            url: '/wap/campaign'
          })
          // window.location.replace(path)
          router.push(path)
        }
      }
      // 创建关键词覆盖订单
      if (isKwCover) {
        // 检查余额
        
        const validResult = await dealResponsePriceValid(isTeamMember, validParams)
        if (!validResult) {
          return
        }
        Dialog.confirm({
          message: 'Are you sure to start the order?',
          confirmButtonText: 'Ok',
          cancelButtonText:'Cancel'
        }).then(async() => {
          res = await createKeyWordsCoverOrder.call(this._vm, ctx)
          path='/wap/order?orderId='+res?.data+'&type=keyword'
          if (res) {
            await Dialog.alert({
              message: 'We have received your order and will contact you within 24h.'
            },
            { showClose: false })
            await post('/Tracking/eventTrack', {
              id: window.$mine.id,
              modules: 'SERVICES',
              clickTime: new Date().getTime(),
              serviceName: getTrackServiceName(ctx.state.serviceType),
              operationType: 'CLICK',
              op: 'submit',
              deviceType: isMobile() ? 2 : 1,
              url: '/wap/campaign'
            })
            // window.location.replace(path)
            router.push(path)
          }
        })
      }
      
      return
    } else {
      // 检查余额
      const validResult = await dealResponsePriceValid(isTeamMember, validParams)
      if (!validResult) {
        return
      }
      // aso service下单
      if (ctx.state.serviceType === 'ASO_SERVICE') {
        const res = await createAsoServiceOrder.call(this._vm, ctx)
        if (res) {
          await Dialog.alert({
            message: 'We have received your order and will contact you within 24h.'
          },{ showClose: false })
          await post('/Tracking/eventTrack', {
            id: window.$mine.id,
            modules: 'SERVICES',
            clickTime: new Date().getTime(),
            serviceName: getTrackServiceName(ctx.state.serviceType),
            operationType: 'CLICK',
            op: 'submit',
            deviceType: isMobile() ? 2 : 1,
            url: '/wap/campaign'
          })
          window.location.replace('/wap/order?type=aso')
        }
        return
      }
      if (ctx.state.serviceType === 'API_SERVICES') {
        const order = {
          id: ctx.state.apiServiceInstall.id,
          now: ctx.state.apiServiceInstall.old === ctx.state.apiServiceInstall.now ? 2 : 1
        }
        if(ctx.state.promoCode.code && (ctx.state.promoCode.type === 'API_SERVICES')){
          order.promoCode = ctx.state.promoCode.code,
          order.deduct = (ctx.state.deduct * ctx.state.promoCode.reward / 100)
          order.now = 2
        }
        const res = await post('/MyApiService/createApiService', {
          order: {
            id: ctx.state.apiServiceInstall.id,
            now: ctx.state.apiServiceInstall.old === ctx.state.apiServiceInstall.now ? 2 : 1
          }
        })
        if (res) {
          await Dialog.alert({
            message: 'The purchase is successful, go to the API to view the remaining credits.'
          },{ showClose: false })
          window.location.replace('/wap/mine/api-support')
        }
        return
      }
    }
    if (ctx.state.serviceType !== 'API_SERVICES') {
      await post('/Tracking/eventTrack', {
        id: window.$mine.id,
        modules: 'SERVICES',
        clickTime: new Date().getTime(),
        serviceName: getTrackServiceName(ctx.state.serviceType),
        operationType: 'CLICK',
        op: 'start',
        deviceType: isMobile() ? 2 : 1,
        url: '/wap/campaign'
      })
    }

    //开始订单
    Dialog.confirm({
      message: 'Are you sure to start the order?',
      confirmButtonText: 'Ok',
      cancelButtonText:'Cancel'
    }).then(async() => {
      let maker_order = makeOrder(ctx)
      const res = await post('MyOrder/addOrder', { ...maker_order, order: { ...maker_order.order, origin: 0 }})
      if (res) {
        if (res.code !== 0) {
          await Dialog.alert({ message: res.msg }, { showClose: false })
          await ctx.dispatch('getOrderPrecondition')// 出现诸如价格变动等错误后，重新刷新订单前置条件
          return
        }
        const startResult = await post('MyOrder/startOrder', { orderId: res.data.id })
        if (startResult) {
          if (startResult.code !== 0||startResult?.data?.error) {
            await Dialog.alert({ message: startResult.msg||startResult?.data?.error }, { showClose: false })
            await ctx.dispatch('getOrderPrecondition')// 出现诸如价格变动等错误后，重新刷新订单前置条件
            return
          } else {
            await post('/Tracking/eventTrack', {
              id: window.$mine.id,
              modules: 'SERVICES',
              clickTime: new Date().getTime(),
              serviceName: getTrackServiceName(ctx.state.serviceType),
              operationType: 'CLICK',
              op: 'start_ok',
              deviceType: isMobile() ? 2 : 1,
              url: '/wap/campaign'
            })
            ctx.dispatch('user/getBalance', {}, { root: true })
            if(serviceType==='SMART_CAMPAIGN'){
              await smartAddKeywords(ctx)
            }
            // window.location.replace('/wap/home')
            router.push('/wap/order')
          }
        }
      }
    }).catch(async() => {
      await post('/Tracking/eventTrack', {
        id: window.$mine.id,
        modules: 'SERVICES',
        clickTime: new Date().getTime(),
        serviceName: getTrackServiceName(ctx.state.serviceType),
        operationType: 'CLICK',
        op: 'start_cancel',
        deviceType: isMobile() ? 2 : 1,
        url: '/wap/campaign'
      })
    })
  },
  async startPromote(ctx){
    if (!(await checkOrder(ctx))) {
      return
    }
    if(ctx.getters.orderOptForCurrentPlatform && ctx.getters.orderOptForCurrentPlatform.warnings
      &&(ctx.state.serviceType==='RATING'||ctx.state.serviceType==='REVIEW'||ctx.state.serviceType==='GUARANTEED_REVIEWS'||ctx.state.serviceType==='CAMPAIGN'||ctx.state.serviceType==='SMART_CAMPAIGN')
    ){
      // 保存订单
      Dialog.confirm({ allowHtml: true,message: ctx.getters.orderOptForCurrentPlatform&& ctx.getters.orderOptForCurrentPlatform.warningsTips,className:'terms-dialog' }).then(async () => {
        await ctx.dispatch('startPromoteConfirm')
      }).catch(() => {
        
      })
    }else{
      await ctx.dispatch('startPromoteConfirm')
    }
  },
  async getSingleOptInfo(ctx, data) {
    const res = await post('/MyOrderOpt/getSingleOptInfo', {
      platform: data.platform,
      optType: data.serviceType
    })
    if (res.code === 0) {
      ctx.commit('setSingleOptInfo', res.data)
    }
  },
  //promocode
  //订单折扣， 服务， 金额， 可用
  async getServicePromoCodeList(ctx, {offerType, service, amount, type = 1}) {
    console.log(amount)
    type = Number(type)
    const serviceCount = _PromoCode.findTypeForList(service)
    const params = {
      offerType,
      type,
      service: serviceCount,
      amount: amount ? Number(amount) * 100 : 0
    }
    const res = await getPromocodeListForService(params);
    let useList
    let unUseList
    if (res) {
      useList = res.available || []
      unUseList = res.unAvailable || []
      useList.sort((a, b) => {
        if (a.reward > b.reward) {
          return -1
        } else {
          return 1
        }
      })
      unUseList.sort((a, b) => {
        if (a.reward > b.reward) {
          return -1
        } else {
          return 1
        }
      })
      ctx.commit('setPromoList', {
        useList,
        unUseList
      })
    }
    const whiteList = ['API_SERVICES']
    let pirceType = null
    if(!whiteList.includes(service)){
      pirceType = (service === 'API_SERVICES' || service === 'ASO_SERVICE') ? 
        await ctx.getters['newStepPriceNoFirstGetter'].type : 
        await ctx.getters['newStepPriceGetter'].type
    }
    if(pirceType && pirceType !== 'member'){
      return
    }
    const defaultPromo = {
      code: useList[0] ? useList[0].code : '',
      amount: amount,
      service: serviceCount,
      serviceStr: service
    }
    ctx.dispatch('handleValidPromoCode', defaultPromo)
  },
  //优惠卷检测
  /* 
    code: String   优惠码
    amount: Number   价格
    service: Number   服务字符串，与common中匹配
    serviceStr: String   服务字符串 方便下单时校验类型是否正确
  */

  async handleValidPromoCode(ctx, {code, amount, service, serviceStr = ctx.state.serviceType}) {

    console.log(amount, )
    if (!code.replace(/\s/g, '').length) {
      // this.valid = false
      ctx.commit('setPromoCode', {
        type: '',
        code: '',
        reward: null
      })
      return
    }

    const res = await usePromoCode({ code, amount: Number(amount) * 100, service })

    if(res.codeError === 'VALID' && res.reward){
      const reward = res.reward / 100
      ctx.commit('setPromoCode', {
        type: serviceStr,
        code: code,
        reward: reward
      })
      ctx.commit('setDeductPrice', Number(amount) * 100)
    } else {
      const errorMessage = status[res.codeError]
      ctx.commit('setPromoCode', {
        type: '',
        code: '',
        reward: null
      })
      Dialog.alert({ message: `${errorMessage}` }, { showClose: false })
    }
  }
}



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
